document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-guide-toc]').forEach((toc) => {
    const root = toc.closest('.meruzy-guide');
    const content = root?.querySelector('[data-guide-content]');
    const list = toc.querySelector('ol');
    if (!content || !list) return;

    const headings = [...content.querySelectorAll('h2')];
    if (headings.length < 2) {
      toc.hidden = true;
      return;
    }

    const used = new Set();
    headings.forEach((heading, index) => {
      let id = heading.id || heading.textContent.trim().toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
      if (!id) id = `section-${index + 1}`;
      const base = id;
      let suffix = 2;
      while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) id = `${base}-${suffix++}`;
      used.add(id);
      heading.id = id;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    });
  });
});
